import React from 'react';

import Card from "@mui/joy/Card";
import CardContent from "@mui/joy/CardContent";
import {CircularProgress, Stack,} from "@mui/joy";
import Typography from "@mui/joy/Typography";
import Button from "@mui/joy/Button";
import Chip from "@mui/joy/Chip";
import Box from "@mui/joy/Box";

import {Handle, Position} from "reactflow";

// components
import BaseApi from "../../utils/BaseApi";
import CommonEditModal from "../Common/CommonEditModal";
import AgentNodeCreate from "./AgentNodeCreate";
import {CommonJSONField} from "../Common/CommonJSONFieldForm";
import CommonCallBackButton from "../Common/CommonCallBackButton";

// icons
import OpenWithIcon from '@mui/icons-material/OpenWith';
import IconButton from "@mui/joy/IconButton";
import DeleteIcon from "@mui/icons-material/Delete";



class AgentNode extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            agentNode: props.data.obj,
        };
    }

    async componentDidMount() {
        // await this.retrieveAgentNode()
    }

    async retrieveAgentNode() {
        this.setState(
            {
                agentNode: null
            }
        )
        const url = `agent_node/${this.state.agentNode.id}/`;
        const api = new BaseApi();
        let response = await api.get(url, {});
        this.setState(
            {
                agentNode: response.data
            }
        )
    }

    async editCallBack(){
        await this.retrieveAgentNode();
        await this.props.data.callBack();
    }

    async rebuildVariables(){
        const url = `agent_node/${this.state.agentNode.id}/rebuild_variables/`;
        const api = new BaseApi();
        await api.get(url, {});
        await this.retrieveAgentNode();
    }

    async delete(){
        const url = `agent_node/${this.state.agentNode.id}/`;
        const api = new BaseApi();
        await api.delete(url, {});
        await this.props.data.callBack()
    }

    async onSubmit(event) {
        event.preventDefault();
        let formDataObj = Object.fromEntries(
            (new FormData(event.currentTarget)).entries()
        );
        for (const [key, value] of Object.entries(formDataObj)) {
            formDataObj[key] = JSON.parse(value)
        }
        const url = `agent_node/${this.state.agentNode.id}/`;
        const api = new BaseApi();
        await api.patch(
            url,
            formDataObj
        );
    }

    render() {
        if (!this.state.agentNode){
            return (<CircularProgress/>)
        }

        return (
            <>
                <Card
                    variant={'soft'}
                    sx={{
                        width: '500px'
                    }}
                    size={'sm'}
                >
                    <CardContent>
                        <Stack
                            spacing={1}
                        >
                            <Stack
                                direction={'row'}
                                spacing={1}
                            >
                                <Stack
                                    sx={{
                                        position: 'relative',
                                    }}
                                    direction={'row'}
                                >
                                <Chip
                                    color={this.state.agentNode.node_class_meta.color}
                                >
                                    {this.state.agentNode.xtype_human}
                                </Chip>
                                <CommonEditModal
                                    overlay={true}
                                    fields={
                                        [
                                            'xtype',
                                        ]
                                    }
                                    baseUrl={'agent_node'}
                                    obj={this.state.agentNode}
                                    callBack={this.retrieveAgentNode.bind(this)}
                                />
                                </Stack>
                                <Button
                                    size={'sm'}
                                    onClick={this.rebuildVariables.bind(this)}
                                    color={'default'}
                                >
                                    Перестроить переменные
                                </Button>
                            </Stack>
                            <Stack
                                direction="row"
                                justifyContent="space-between"
                                alignItems="center"
                                spacing={2}
                            >
                                <Typography
                                    level={'title-md'}
                                >
                                {this.state.agentNode.title}
                                </Typography>
                                <CommonEditModal
                                    fields={
                                        [
                                            'title',
                                            'description',
                                        ]
                                    }
                                    baseUrl={'agent_node'}
                                    obj={this.state.agentNode}
                                    callBack={this.editCallBack.bind(this)}
                                />
                                <IconButton
                                    className="custom-drag-handle"
                                >
                                    <OpenWithIcon/>
                                </IconButton>
                            </Stack>
                            <div dangerouslySetInnerHTML={{__html: this.state.agentNode.description}} />
                            <form
                                onSubmit={this.onSubmit.bind(this)}
                            >
                                <Stack
                                    spacing={1}
                                >
                                    <Typography>
                                        Переменные запроса
                                    </Typography>
                                    <CommonJSONField
                                        defaultValue={this.state.agentNode.request_variables}
                                        name={'request_variables'}
                                    />
                                    <Typography>
                                        Раскладка переменных ответа
                                    </Typography>
                                    <CommonJSONField
                                        defaultValue={this.state.agentNode.response_variables_mapping}
                                        name={'response_variables_mapping'}
                                    />
                                    <Button type="submit" fullWidth>
                                        Сохранить
                                    </Button>
                                </Stack>
                            </form>

                            <AgentNodeCreate
                                agentNode={this.state.agentNode}
                                callBack={this.props.data.callBack}
                                title={'Добавить узел'}
                            />
                            <Box>
                                { !this.state.agentNode.root?
                                    <CommonCallBackButton
                                        icon={DeleteIcon}
                                        label={'Удалить'}
                                        color={'danger'}
                                        variant={'plain'}
                                        callBack={this.delete.bind(this)}
                                    />:
                                    null
                                }
                            </Box>
                        </Stack>

                    </CardContent>
                </Card>
                <Handle
                    type="target"
                    // isConnectable={this.props.isConnectable}
                    position={Position.Left}
                    style={{
                        background: "green",
                        width: 0,
                        height: 0,
                    }}
                />
                <Handle
                    type="source"
                    // isConnectable={this.props.isConnectable}
                    position={Position.Right}
                    style={{
                        background: "red",
                        width: 0,
                        height: 0,
                    }}
                    id="blue"
                />
            </>
        )
    }
}

export default AgentNode;
